module.exports = __webpack_public_path__ + "static/media/check.2be85a10.png";